import * as React from "react";
// import { pure } from 'recompose';
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import * as Utils from "@Cyclope-Utils/index";
import * as i18next from "i18next";

// import Stream from '@tunnel-components/@sharded/widgets/stream/component';
import { isLessThan30Days /*,isLessThan7Days */ } from "@Cyclope-Utils/index";
// import { Link } from 'react-router-dom';
// import * as Paths from '@tunnel-enums/index';
import * as cx from "classnames";
import * as Enums from "@tunnel-enums/index";
import * as Lodash from "lodash";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    Elem,
    onDeletedSimulation /*onClose,*/,
    // falseAlert,// startTimeAction,
    // onStartTimeAction,onFalseAlert,
    // onCameraSectionName,// cameraSection,
    onActive,
    arrayOfIncident,
    // key
    // incident,actionloading, onExtractImpact, onExtractVideo
  } = props;
  /**
   * @description : retourne un objet
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  const SYSTEMVIEWTUBES: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.SYSTEMVIEWTUBES,
  ]);

  /**
   * @description : le tableua relatif
   * à la position de l'incidents
   * @const
   * @name dataCar
   * @type { strin[]  }
   */
  const dataCar: string[] = [
    i18next.t("voie de gauche"),
    i18next.t("voie de droite"),
    i18next.t("parking"),
    i18next.t("bau"),
    i18next.t("trottoir"),
  ];
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name i18next
   * @name react-router-dom
   * @infos "https://reactjs.org"
   */

  return (
    <section
      className={cx("arrayContent", { arrayContentActive: arrayOfIncident })}
      style={{ cursor: "pointer" }}
    >
      <span
        className="arraysContentSpanAuto"
        onClick={onActive}
        style={{ width: "10%" }}
      >
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p>{!!Elem && Elem.id}</p>
          </div>
        </div>
      </span>
      <span
        className="arraysContentSpanAuto"
        onClick={onActive}
        style={{ width: "16%" }}
      >
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p style={{ cursor: "auto", width: "100%" }}>
              {Utils.localDateFrSecondFormat(!!Elem && Elem.startTime)}
            </p>
          </div>
          <Styled.BreadBoxContainer
            isVisible={true}
            style={{ width: "auto", top: "10px", color: "black" }}
            className="isVisible"
          >
            {Utils.localDateFrSecondFormat(!!Elem && Elem.startTime)}
          </Styled.BreadBoxContainer>
        </div>
      </span>
      {!!Elem && Elem.camera && (
        <span
          className="arraysContentSpanAuto"
          onClick={onActive}
          style={{ width: "11%" }}
        >
          <div className="arraysContentContenair">
            <div className="arrayContentInfos">
              {!!Elem && !Elem.fake && (
                <p style={{ paddingLeft: "10px" }}>
                  {!!Elem && dataCar[Elem.vehiclePosition]}
                </p>
              )}
              {!!Elem && Elem.fake && (
                <p
                  onClick={onActive}
                  style={{
                    cursor: "pointer",
                    color: "#007ADF",
                    fontWeight: 500,
                  }}
                >
                  {" "}
                  {i18next.t("simulation")}
                </p>
              )}
            </div>
          </div>
        </span>
      )}
      {SYSTEMVIEWTUBES && !!Elem && Elem.camera && Elem.camera.section && (
        <span
          className="arraysContentSpanAuto"
          onClick={onActive}
          style={{ width: "12%" }}
        >
          <div className="arraysContentContenair">
            <div className="arrayContentInfos">
              <p
                style={{
                  cursor: "auto",
                  color: Elem.camera.section.colorRgbString,
                }}
              >
                {!!Elem && Elem.camera.section.name}
              </p>
            </div>
            <Styled.BreadBoxContainer
              className={
                !!Elem &&
                !!Elem.camera &&
                !!Elem.camera.section &&
                Elem.camera.section.name.length > 13
                  ? "isVisible"
                  : ""
              }
              isVisible={
                !!Elem &&
                !!Elem.camera &&
                !!Elem.camera.section &&
                Elem.camera.section.name.length > 13
              }
              style={{
                width: "auto",
                minWidth: "100px",
                top: "10px",
                color: Elem.camera.section.colorRgbString,
              }}
            >
              {!!Elem && Elem.camera.section.name}
            </Styled.BreadBoxContainer>
          </div>
        </span>
      )}
      {!!Elem && Elem.camera && (
        <span
          className="arraysContentSpanAuto"
          onClick={onActive}
          style={{ width: "10%" }}
        >
          <div className="arraysContentContenair">
            <div className="arrayContentInfos">
              <p>{!!Elem && Elem.camera.code}</p>
            </div>
          </div>
        </span>
      )}

      <span
        className="arraysContentSpanAuto"
        onClick={onActive}
        style={{ width: "10%" }}
      >
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p>{i18next.t(`${!!Elem && Elem.label}`)}</p>
          </div>
        </div>
      </span>
      <span
        className="arraysContentSpanAuto"
        onClick={onActive}
        style={{ width: "10%" }}
      >
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            <p>{!!Elem && Elem.duration}</p>
          </div>
        </div>
      </span>

      <span
        className="arraysContentSpanAuto"
        onClick={onActive}
        style={{ width: "11%" }}
      >
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            {!!Elem && !Elem.qualified && <p> {i18next.t("a qualifier")} </p>}
            {!!Elem &&
              Elem.qualified &&
              Elem.truePositive &&
              !Lodash.isEqual(Elem.qualificationMotifAs, "WEB") &&
              !Lodash.isEqual(Elem.qualificationMotifAs, "SAE") &&
              !Lodash.isEqual(Elem.qualificationMotifAs, "FILTER") && (
                <p>{i18next.t("avere")}</p>
              )}
            {!!Elem &&
              Elem.qualified &&
              Elem.falsePositive &&
              Lodash.isEqual(Elem.qualificationMotifAs, null) && (
                <p>{i18next.t("fausse alerte")}</p>
              )}
            {!!Elem &&
              Elem.qualified &&
              Elem.falsePositive &&
              !Lodash.isEqual(Elem.qualificationMotifAs, null) &&
              !Lodash.isEqual(Elem.qualificationMotifAs, "WEB") &&
              !Lodash.isEqual(Elem.qualificationMotifAs, "SAE") && (
                <p>
                  {" "}
                  {i18next.t("fausse alerte")}:{" "}
                  {i18next.t(`${Elem.qualificationMotifAs}`)}
                </p>
              )}
            {!!Elem &&
              Elem.qualified &&
              !Lodash.isEqual(Elem.qualificationMotifAs, null) &&
              Lodash.isEqual(Elem.qualificationMotifAs, "WEB") &&
              !Lodash.isEqual(Elem.qualificationMotifAs, "SAE") && (
                <p> {i18next.t("inhibe par web")}</p>
              )}
            {!!Elem &&
              Elem.qualified &&
              !Lodash.isEqual(Elem.qualificationMotifAs, null) &&
              !Lodash.isEqual(Elem.qualificationMotifAs, "WEB") &&
              Lodash.isEqual(Elem.qualificationMotifAs, "SAE") && (
                <p> {i18next.t("inhibe par sae")}</p>
              )}
            {!!Elem &&
              Elem.qualified &&
              !Lodash.isEqual(Elem.qualificationMotifAs, null) &&
              !Lodash.isEqual(Elem.qualificationMotifAs, "WEB") &&
              !Lodash.isEqual(Elem.qualificationMotifAs, "SAE") &&
              Lodash.isEqual(Elem.qualificationMotifAs, "FILTER") && (
                <p> {i18next.t("filtre par web")}</p>
              )}
          </div>
          {!!Elem &&
            Elem.qualified &&
            Elem.falsePositive &&
            !Lodash.isEqual(Elem.qualificationMotifAs, null) &&
            !Lodash.isEqual(Elem.qualificationMotifAs, "WEB") &&
            !Lodash.isEqual(Elem.qualificationMotifAs, "SAE") && (
              <Styled.BreadBoxContainer
                isVisible={true}
                className="isVisible"
                style={{ width: "auto", top: "10px", color: "black" }}
              >
                {i18next.t("fausse alerte")} :{" "}
                {i18next.t(`${Elem.qualificationMotifAs}`)}
              </Styled.BreadBoxContainer>
            )}
          {!!Elem &&
            Elem.qualified &&
            !Lodash.isEqual(Elem.qualificationMotifAs, null) &&
            Lodash.isEqual(Elem.qualificationMotifAs, "WEB") &&
            !Lodash.isEqual(Elem.qualificationMotifAs, "SAE") && (
              <Styled.BreadBoxContainer
                isVisible={true}
                className="isVisible"
                style={{ width: "auto", top: "10px", color: "black" }}
              >
                {i18next.t("inhibe par web")}
              </Styled.BreadBoxContainer>
            )}
          {!!Elem &&
            Elem.qualified &&
            !Lodash.isEqual(Elem.qualificationMotifAs, null) &&
            !Lodash.isEqual(Elem.qualificationMotifAs, "WEB") &&
            Lodash.isEqual(Elem.qualificationMotifAs, "SAE") && (
              <Styled.BreadBoxContainer
                isVisible={true}
                className="isVisible"
                style={{ width: "auto", top: "10px", color: "black" }}
              >
                {i18next.t("inhibe par sae")}
              </Styled.BreadBoxContainer>
            )}
          {!!Elem &&
            Elem.qualified &&
            !Lodash.isEqual(Elem.qualificationMotifAs, null) &&
            Lodash.isEqual(Elem.qualificationMotifAs, "FILTER") && (
              <Styled.BreadBoxContainer
                isVisible={true}
                className="isVisible"
                style={{ width: "auto", top: "10px", color: "black" }}
              >
                {i18next.t("filtre par web")}
              </Styled.BreadBoxContainer>
            )}
        </div>
      </span>
      <span
        className="arraysContentSpanAuto"
        onClick={onActive}
        style={{ width: "11%" }}
      >
        <div className="arraysContentContenair">
          <div className="arrayContentInfos">
            {isLessThan30Days(Elem) &&
              !Elem.fake &&
              !!Elem &&
              (Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.INCIDENTFILEEXPORTERPDF,
              ]) ||
                Utils.simpleAuthorizationIsAllowed(User, [
                  Enums.AuthorizationRightsEnums.INCIDENTFILEEXPORTERVIDEO,
                ])) && (
                <p
                  style={{ cursor: "pointer" }}
                  className="arraysAction"
                  onClick={onActive}
                >
                  {" "}
                  {i18next.t("extraire")}
                </p>
              )}

            {!!Elem &&
              Elem.fake &&
              !Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.SIMULATORDELECTED,
              ]) && (
                <p
                  style={{
                    cursor: "default",
                    backgroundColor: "white",
                    padding: "9px 7px",
                    width: "80px",
                    color: "white",
                    borderRadius: "3px",
                  }}
                >
                  {i18next.t("supprimer")}
                </p>
              )}

            {!isLessThan30Days(Elem) && !Elem.fake && !!Elem && (
              <p style={{ cursor: "default", padding: "8px 0px" }}>
                <svg
                  width="14"
                  height="14"
                  className="outofTimes"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 1.14258V0H0V1.14258C0 1.64023 0.320513 2.06172 0.769231 2.21914V10.7809C0.320513 10.9383 0 11.3598 0 11.8574V13H10V11.8574C10 11.3598 9.67949 10.9383 9.23077 10.7809V2.21914C9.67949 2.06172 10 1.64023 10 1.14258ZM7.69231 10.7148V9.24727C7.69231 8.35352 7.24359 7.52578 6.49231 7.02812L5.69231 6.5L6.49231 5.97187C7.24359 5.47676 7.69231 4.64648 7.69231 3.75273V2.28516H8.46154V10.7148H7.69231ZM2.30769 2.28516V3.75273C2.30769 4.64648 2.75641 5.47422 3.50769 5.97187L4.30769 6.5L3.50769 7.02812C2.75641 7.52324 2.30769 8.35352 2.30769 9.24727V10.7148H1.53846V2.28516H2.30769ZM3.07692 2.28516H6.92308V3.75273C6.92308 4.39004 6.60256 4.98418 6.06667 5.33711L5 6.04297L3.93333 5.33965C3.39744 4.98418 3.07692 4.39258 3.07692 3.75273V2.28516ZM5 6.95703L6.06667 7.66035C6.35385 7.85078 6.57692 8.10723 6.72564 8.40176H3.27436C3.42051 8.10469 3.64615 7.84824 3.93333 7.66035L5 6.95703ZM3.07692 9.24727C3.07692 9.21934 3.07692 9.19394 3.07949 9.16602H6.92308C6.92308 9.19394 6.92564 9.21934 6.92564 9.24727V10.7148H3.07692V9.24727ZM0.769231 0.761719H9.23077V1.14258C9.23077 1.35332 9.05897 1.52344 8.84615 1.52344H1.15385C0.941026 1.52344 0.769231 1.35332 0.769231 1.14258V0.761719ZM9.23077 12.2383H0.769231V11.8574C0.769231 11.6467 0.941026 11.4766 1.15385 11.4766H8.84615C9.05897 11.4766 9.23077 11.6467 9.23077 11.8574V12.2383Z"
                    fill="#ed5b56"
                  />
                </svg>
              </p>
            )}
            {!!Elem &&
              Elem.fake &&
              Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.SIMULATORDELECTED,
              ]) && (
                <p
                  style={{ cursor: "pointer" }}
                  className="arraysAction"
                  onClick={onDeletedSimulation}
                >
                  {i18next.t("supprimer")}
                </p>
              )}
            {!!Elem &&
              Elem.fake &&
              !Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.SIMULATORDELECTED,
              ]) && (
                <p
                  style={{
                    cursor: "default",
                    backgroundColor: "#f3f3f3",
                    padding: "9px 7px",
                    width: "80px",
                    color: "white",
                    borderRadius: "3px",
                  }}
                >
                  {i18next.t("supprimer")}
                </p>
              )}
          </div>
        </div>
      </span>
    </section>
  );
};

Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  Elem?: any;
  onActive?: any;
  classnameIncident?: any;
  actionloading?: any;
  incident?: any;
  fill?: any;
  onExtractImpact?: any;
  onExtractVideo?: any;
  onClose?: any;
  onDeletedSimulation?: any;
  errorExtractionVideo?: any;
  falseAlert?: boolean;
  onFalseAlert?: any;
  onCameraSectionName?: any;
  cameraSection?: boolean;
  startTimeAction?: boolean;
  onStartTimeAction?: any;
  arrayOfIncident?: any;
  key?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/box/explorer/incident/component.tsx